class ApiConstants {
  constructor() { }
  static profileUploadPath = `${process.env.REACT_APP_PUBLIC_API_URL}/uploads/profile/`;
  static HostURL = `${process.env.REACT_APP_PUBLIC_API_URL}`;
  static apiPath = "/api/";
  static url = this.HostURL + this.apiPath;
  static loginUserURL = this.url + "auth/login";
  static forgotPasswordURL = this.url + "auth/forgot-password";
  static verifyResetTokenURL = this.url + "auth/verify-reset-token";
  static resetPasswordURL = this.url + "auth/reset-password";
  static otpVerificationURL = this.url + "auth/verify-otp";
  static logoutURL = this.url + "auth/logout";
  static resendOtpURL = this.url + "auth/resend-otp";
  static dashboardURL = this.url + "dashboard";
  static sideMenuURL = this.url + "side-menu";
  static buidingListURL = this.url + "buildingList";
  static TDBuildingListURL = this.url + "TDBuildingList";
  static AccountListURL = this.url + "accountData";
  static insuranceRenewalTrackerURL = this.url + "insurance-renewal-tracker";
  static insuranceRenewalTrackerAddURL =
    this.url + "insurance-renewal-tracker-store";
  static IR_TrackerStatusListURL =
    this.url + "insurance-renewal-tracker/status-list";
  static termDepositStoreURL = this.url + "term-deposit-store";
  static termDepositUpdateURL = this.url + "term-deposit-update";
  static termDepositCloseURL = this.url + "term-deposit-close";
  static termDepositListURL = this.url + "term-deposit-list";
  static termDepositDetailsURL = this.url + "term-deposit-view";
  static termDepositInstructionSaveURL =
    this.url + "term-deposit-instruction/save";
  static termDepositMoveToLive = this.url + "td-move-to-live";
  static roleURL = this.url + "roles";
  static userURL = this.url + "users";
  static WebMenuURL = this.url + "configurations/web-menu";
  static userProfileURL = this.url + "usersProfile";

  //building API's
  static buildingDetailStoreURL = this.url + "store-building-detail";
  static termDepositSendReminderURL = (id) =>
    `${this.url}term-deposit/reminder/${id}`;
  static termDepositSendReminderPOSTURL = this.url + "term-deposit/reminder";
  static s3FileUploadURL = this.url + "files/upload";
  static s3FileRemoveURL = (key) =>
    `${this.url}files/remove?key=${encodeURIComponent(key)}`;
  static termDepositFormsURL =
    this.url + "term-deposit/get-termdeposit-for-forms";
  static termDepositRollOverStoreURL =
    this.url + "term-deposit/termDepositRollOverStore";
  static termDepositInstructionStore =
    this.url + "term-deposit/termDepositInstructionStore";
  static termDepositCloseRedeem = this.url + "term-deposit/close-redeem";
  static termDepositRollBackURL = (token) =>
    `${this.url}term-deposit/rollback-instructions/${token}`;
  static termDepositSentReminderEmailURL =
    this.url + "termDepositSentReminderEmail";

  // Meeting Resigister API's
  static meetingRegisterListURL = this.url + "meeting-register-list";
  static meetingRegisterStoreURL = this.url + "meeting-register-store";
  static meetingRegisterUpdateURL = this.url + "meeting-register-update";
  static meetingRegisterDeleteURL = this.url + "meeting-register-delete";
  static meetingRegisterUpdateSendDate = this.url + "update-send-date";

  //FYE API's
  static financialYearEndListURL = this.url + "financial-year-end";
  static financialYearEndStoreURL =
    this.url + "store-financial-year-end-detail";
  static syncAuditorNameURL = this.url + "sync-auditor-name";

  // Meeting Register Settings API's
  static meetingConfigurationsListURL = this.url + "meeting-register-settings";
  static meetingConfigurationsUpdateURL =
    this.url + "meeting-register-settings-update";


  static chatCreateURL = this.url + "chats";
  static chatListURL = this.url + "chats";
  static chatHistoryURL = this.url + "chats/messages";
  static chatSendMessageURL = this.url + "chats/send-messages";
  static accountManagerListURL = this.url + "account-manager-list";
}
export default ApiConstants;
